//  Angular imports
import { Component, ElementRef, input, output, signal, viewChild } from '@angular/core';
//  Application imports
import { Utils } from 'app/utils';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'zf-modal',
    templateUrl: './zf-modal.component.html',
    styleUrls: ['./zf-modal.component.scss'],
    imports: [NgClass, NgStyle]
})
export class ZFModalComponent {

    public readonly visible = signal<boolean>(false);
    public readonly duration: number = 500;

    public get footerPresent(): boolean {
        return !!this.footerContent().nativeElement.innerHTML.length;
    }

    public readonly id = input<string>();

    public readonly onClose = output<void>();

    private readonly footerContent = viewChild.required<ElementRef<HTMLDivElement>>('footer');

    public toggle(): void {
        if (this.visible()) {
            this.onClose.emit();
            setTimeout((): void => {
                this.visible.set(false);
                document.body.style.pointerEvents = 'auto';
                document.body.style.overflow = 'auto';
            }, this.duration);
        } else {
            this.visible.set(true);
            document.body.style.pointerEvents = 'none';
            document.body.style.overflow = 'hidden';
        }
        Utils.animate(document.body.classList, this.duration);
    }
}
